import { render, staticRenderFns } from "./OrtodonciaOrtopedia.vue?vue&type=template&id=ea415aac&scoped=true"
import script from "./OrtodonciaOrtopedia.vue?vue&type=script&lang=js"
export * from "./OrtodonciaOrtopedia.vue?vue&type=script&lang=js"
import style0 from "./OrtodonciaOrtopedia.vue?vue&type=style&index=0&id=ea415aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea415aac",
  null
  
)

export default component.exports